var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{on:{"click":_vm.clearToast}},[_vm._v(_vm._s(_vm.buttonText))])
}
var staticRenderFns = []

export { render, staticRenderFns }